import objectPath from 'object-path';

const initializeWhitlabelMap = jsonString => {
  if (!jsonString) return {};
  const mapObject = JSON.parse(WHITELABEL_MAP);
  Object.keys(mapObject).forEach(key => {
    if (typeof key !== 'string') {
      mapObject[key] = mapObject[key].url || MAIN_URL;
    }
  });
  return mapObject;
};

export const getWhitelabelConfig = () => window.WHITE_CONF;

export const inWhitelabel = () => !!getWhitelabelConfig();

export const whitelabelMap = initializeWhitlabelMap(WHITELABEL_MAP);

export const isPathExcluded = path => {
  const config = getWhitelabelConfig();
  const excludedPaths = objectPath.get(config, 'excludedPaths', []);
  return (
    !!excludedPaths &&
    excludedPaths.findIndex(excluded => RegExp(excluded).test(path)) >= 0
  );
};

const baseColors = {
  main: '#0f2eff',
  mainActive: '#4d88d9',
  mainDark: '#22497F',
};

export const resolveColor = name => {
  const whiteLabelConf = window.WHITE_CONF;
  if (whiteLabelConf) {
    return whiteLabelConf.colors[name];
  }
  return baseColors[name];
};

// FIXME - temporary patch until legacy colors + whitelabels have been migrated
export const whitelabelPatchTheme = theme => {
  if (!inWhitelabel()) {
    return theme;
  }
  const { color, ...patchedTheme } = theme;
  patchedTheme.color = { ...color };
  patchedTheme.color.primary = resolveColor('main');
  patchedTheme.color.primaryLight = resolveColor('mainActive');
  patchedTheme.color.primaryDark = resolveColor('mainDark');
  return patchedTheme;
};

export const whiteLabelPatchRoutes = routes => {
  if (!inWhitelabel()) {
    return routes;
  }
  // const whiteLabelConf = getWhitelabelConfig();
  // TODO FIX THIS FOR WHITELABEL
  // if (Object.keys(whiteLabelConf.pages).length > 1) {
  //   // TODO: base this on white label config object?
  //   routes[0].children.push(
  //     {
  //       name: 'contribute',
  //       path: 'contribute',
  //       children: [{ name: 'issues', path: '/issues' }],
  //     },
  //     {
  //       name: 'connect',
  //       path: 'connect',
  //       children: [
  //         { name: 'members', path: '/members' },
  //         { name: 'organisations', path: '/organisations' },
  //       ],
  //     },
  //     {
  //       name: 'learn',
  //       path: 'learn',
  //       children: [{ name: 'stories', path: '/stories' }],
  //     }
  //   );
  // }
  return routes;
};
